import React, { Component } from 'react';

import SwitchCheckbox from '../SwitchCheckbox.js';
import PermissionsTable from './PermissionsTable.js';
import { withLoggedUser } from '../../Providers/WebServiceProvider.js';

class UserRowCollapsable extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			dirtyChanges: false,
			isSaving: false,
			counter: 0,
			permissionsTable: !this.props.user.isDeleted()
		}

		this.permissionsTable = React.createRef();
		this.changeUserState = this.changeUserState.bind(this);
	}

	updateDirtyState = (value) => {
		this.setState({ dirtyChanges: value });
	}

	updateSavingState = (value) => {
		this.setState({ isSaving: value });
	}

	changeUserState (state) {
		const that = this;

		this.updateSavingState(true);

		if (state) {
			let enabled = this.props.enabler(this.props.user);
			if (enabled) {
				enabled.then(function (updatedUser) {
					that.updateSavingState(false);
					that.props.disabledBeacon(false);
					that.setState({ permissionsTable: true });
				})
			}
		} else {
			let deleted = this.props.deleter(this.props.user);
			if (deleted) {
				deleted.then(function () {
					that.updateSavingState(false);
					that.props.disabledBeacon(true);
					that.setState({ permissionsTable: false });
				})
			}
		}
	}

	onUpdate = (param) => (value) => {
    const that = this;

    this.props.user.props[param] = (value === "") ? null : value;

    return new Promise((resolve, reject) => {
      let updated = that.props.updater(that.props.user, param, that.props.user.props[param]);
      if (updated) {
        updated.then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      }
    });
	}

	render () {
		const accordionStyle = {
			display: this.props.folded ? 'none' : ''
		};

		let submitChangesFunc = (!this.permissionsTable.current) ? () => {} : this.permissionsTable.current.onSubmitChanges;

		let saveChangesClasses = ['button', 'is-primary', 'is-gradient'];

		return (
			<div className="user-row-collapsable" style={accordionStyle}>
				<div className="section">
					{
						!this.state.permissionsTable ? null : (
							<div className="user-permissions-table">
								<PermissionsTable
									server={{
										actions: this.props.serverTokens.actions,
										tokens:  this.props.serverTokens.tokens
									}}
									onSaveChanges={this.onUpdate('permissions')}
									dirtyBeacon={this.updateDirtyState}
									savingBeacon={this.updateSavingState}
									ref={this.permissionsTable}
									user={this.props.user.getAbilities()}
								/>
							</div>
						)
					}
					<div className="user-actions">
						<div className="level">
							<div className="level-left">
								<div className="level-item">
									{
										this.props.webServiceContext.auth.getUser().props.id === this.props.user.props.id
											? null
											: (<SwitchCheckbox
													labels={['Enable User:', 'Disable User:']}
													onChange={this.changeUserState}
													checked={!this.props.user.isDeleted()}
												/>)
									}
								</div>
							</div>
							<div className="level-right">
								<div className="level-item">
									{
										!this.state.permissionsTable ? null : (<input
											disabled={!this.state.dirtyChanges || this.state.isSaving}
											onClick={submitChangesFunc}
											type="button"
											value={(this.state.isSaving) ? 'Saving...': 'Save Changes'}
											className={saveChangesClasses.join(" ")} readOnly />)
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withLoggedUser(UserRowCollapsable);



// WEBPACK FOOTER //
// ./src/Components/Users/UserRowCollapsable.js